var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vks-mapping-row-details",
      style: { borderLeftColor: _vm.accentColor },
    },
    [
      _c(
        "table",
        { staticClass: "table table-sm vks-mapping-row-details-table" },
        [
          _c("thead", [
            _c(
              "tr",
              _vm._l(_vm.detailColumns, function (column) {
                return _c(
                  "th",
                  {
                    key: column.key,
                    style: {
                      backgroundColor: _vm.accentColor,
                      color: "#ffffff",
                    },
                  },
                  [_vm._v(" " + _vm._s(column.label) + " ")]
                )
              }),
              0
            ),
          ]),
          _c(
            "tbody",
            _vm._l(_vm.details, function (entry, index) {
              return _c(
                "tr",
                { key: `${entry.label || entry.region || "detail"}-${index}` },
                _vm._l(_vm.detailColumns, function (column) {
                  return _c("td", { key: `${column.key}-${index}` }, [
                    _vm._v(" " + _vm._s(_vm.formatCell(entry, column)) + " "),
                  ])
                }),
                0
              )
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }